import React from "react";
import {
    Box,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Table
} from '@material-ui/core';
import moment from 'moment';
export default class ComponentToPrint extends React.Component {
    render() {
        const supplierWiseGrnItemDetails = this.props.supplierWiseGrnItemDetails;
        const SearchData = this.props.SearchData;
        const fromDate = this.props.fromDate;
        const toDate = this.props.toDate;

        const cellStyle = {
            border: '1px solid black',
            padding: '1px',
            fontSize: '0.9rem',
        };

        return (
            <div>
                <h2><center><u>Supplier Wise GRN Item Detail Report</u></center></h2>
                <div>&nbsp;</div>
                <h2><center>{SearchData.groupName} - {SearchData.factoryName}</center></h2>
                <div>&nbsp;</div>
                <h2><center>{moment(fromDate).format('').split('T')[0]} - {moment(toDate).format('').split('T')[0]}</center></h2>
                <div>
                    <Box minWidth={1050}>
                        <TableContainer >
                            <Table aria-label="caption table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align={'center'} style={cellStyle}>Supplier Name</TableCell>
                                        <TableCell align={'center'} style={cellStyle}>Item catogory</TableCell>
                                        <TableCell align={'center'} style={cellStyle}>Item</TableCell>
                                        <TableCell align={'center'} style={cellStyle}>PO number</TableCell>
                                        <TableCell align={'center'} style={cellStyle}>Invoice number</TableCell>
                                        <TableCell align={'center'} style={cellStyle}>Invoice date</TableCell>
                                        <TableCell align={'center'} style={cellStyle}>Item receive date</TableCell>
                                        <TableCell align={'center'} style={cellStyle}>Quantity</TableCell>
                                        <TableCell align={'center'} style={cellStyle}>Unit price</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {supplierWiseGrnItemDetails.map((data, index) => (
                                        <TableRow key={index}>
                                            <TableCell align={'center'} component="th" scope="row" style={{ border: '1px solid black', padding: '1px', textAlign: 'left', fontSize: '0.9rem' }}>
                                                {data.supplierName}
                                            </TableCell>
                                            <TableCell align={'center'} component="th" scope="row" style={cellStyle}>
                                                {data.itemCatogory}
                                            </TableCell>
                                            <TableCell align={'center'} component="th" scope="row" style={cellStyle}>
                                                {data.item}
                                            </TableCell>
                                            <TableCell align={'center'} component="th" scope="row" style={cellStyle}>
                                                {data.purchaseOrderNumber}
                                            </TableCell>
                                            <TableCell align={'center'} component="th" scope="row" style={cellStyle}>
                                                {data.invoiceNumber}
                                            </TableCell>
                                            <TableCell align={'center'} component="th" scope="row" style={cellStyle}>
                                                {data.invoiceDate.split('T')[0]}
                                            </TableCell>
                                            <TableCell align={'center'} component="th" scope="row" style={cellStyle}>
                                                {data.itemReceivedDate.split('T')[0]}
                                            </TableCell>
                                            <TableCell align={'center'} component="th" scope="row" style={cellStyle}>
                                                {data.quantity}
                                            </TableCell>
                                            <TableCell align={'center'} component="th" scope="row" style={{ border: '1px solid black', padding: '1px', textAlign: 'right', fontSize: '0.9rem' }}>
                                                {data.unitPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </div>
                <div>&nbsp;</div>
                <h3><center>***** End of List *****</center></h3>
            </div>
        );

    }

}